// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2SMrF","right":"styles_right__3ayZs"};